var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80929 6L9.91085 1.11094C9.9796 1.02969 9.92179 0.90625 9.81554 0.90625H8.56866C8.49522 0.90625 8.42491 0.939062 8.37647 0.995312L4.99366 5.02813L1.61085 0.995312C1.56397 0.939062 1.49366 0.90625 1.41866 0.90625H0.171787C0.0655366 0.90625 0.00772404 1.02969 0.076474 1.11094L4.17804 6L0.076474 10.8891C0.0610734 10.9072 0.0511933 10.9293 0.0480064 10.9529C0.0448195 10.9764 0.0484596 11.0004 0.0584949 11.022C0.0685302 11.0435 0.0845393 11.0617 0.104621 11.0745C0.124703 11.0872 0.148014 11.0939 0.171787 11.0938H1.41866C1.4921 11.0938 1.56241 11.0609 1.61085 11.0047L4.99366 6.97188L8.37647 11.0047C8.42335 11.0609 8.49366 11.0938 8.56866 11.0938H9.81554C9.92179 11.0938 9.9796 10.9703 9.91085 10.8891L5.80929 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.56ce608a0d7cd71007285fc0b14e65f7.svg";
export { ForwardRef as ReactComponent };